import { DemographicsLegend, LegendEntry } from '../DemographicsLegend';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { FunctionComponent, useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { Cell, Pie, PieChart } from 'recharts';
import { spacingHelper } from '@property.com.au/ui-kit';
import { SubBrickTitle } from '../SubBrickTitle';
import { ColorVariant, mapColorVariantToBarStyle } from '../../../../../helpers/colorVariant';

const CHART_DIMENSIONS: { height: number; width: number } = {
  height: 110,
  width: 110,
};

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-area: age;
`;

const ChartContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  justify-self: end;
  margin-bottom: ${spacingHelper('extraSmall')};
  width: ${CHART_DIMENSIONS.width}px;
  height: ${CHART_DIMENSIONS.height}px;
`;

type PieGraphSlice = {
  value: number;
  colorVariant: ColorVariant;
};

interface HouseholdsSubBrickProps {
  title: string;
  subtitle: string;
  legendEntries: LegendEntry[];
  pieGraphSlices: PieGraphSlice[];
  className?: string;
}

export const HouseholdsSubBrick: FunctionComponent<HouseholdsSubBrickProps> = ({
  title,
  subtitle,
  legendEntries,
  pieGraphSlices,
  className,
}: HouseholdsSubBrickProps) => {
  const theme = useTheme();

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const pieGraphData = pieGraphSlices.map((pieGraphSlice) => ({
    value: pieGraphSlice.value,
    style: mapColorVariantToBarStyle(pieGraphSlice.colorVariant, theme),
  }));

  return (
    <ContentBrick
      titleComponent={<SubBrickTitle as="h3">{title}</SubBrickTitle>}
      subtitle={subtitle}
      isSubBrick={true}
      className={className}
    >
      <Content>
        <DemographicsLegend legendEntries={legendEntries} />
        <ChartContainer>
          {isClient && (
            <PieChart width={CHART_DIMENSIONS.width} height={CHART_DIMENSIONS.height}>
              <Pie
                data={pieGraphData}
                dataKey="value"
                innerRadius={38}
                outerRadius={55}
                cx="50%"
                cy="50%"
                rootTabIndex={-1}
              >
                {pieGraphData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.style.barColor}
                    style={{ pointerEvents: 'none' }}
                  />
                ))}
              </Pie>
            </PieChart>
          )}
        </ChartContainer>
      </Content>
    </ContentBrick>
  );
};
